import React from 'react';
import { Select } from 'antd';

const { Option, OptGroup } = Select;

const departementsParRegion = {
  'Dakar': ['Dakar', 'Pikine', 'Guédiawaye', 'Rufisque'],
  'Thiès': ['Thiès', 'Mbour', 'Tivaouane'],
  'Saint-Louis': ['Saint-Louis', 'Dagana', 'Podor'],
  'Matam': ['Matam', 'Kanel', 'Ranérou'],
  'Diourbel': ['Diourbel', 'Mbacké', 'Bambey'],
  'Fatick': ['Fatick', 'Foundiougne', 'Gossas'],
  'Kaolack': ['Kaolack', 'Nioro du Rip', 'Guinguinéo'],
  'Kaffrine': ['Kaffrine', 'Koungheul', 'Malem Hoddar', 'Birkelane'],
  'Louga': ['Louga', 'Kébémer', 'Linguère'],
  'Tambacounda': ['Tambacounda', 'Bakel', 'Goudiry', 'Koumpentoum'],
  'Kédougou': ['Kédougou', 'Salémata', 'Saraya'],
  'Ziguinchor': ['Ziguinchor', 'Bignona', 'Oussouye'],
  'Kolda': ['Kolda', 'Vélingara', 'Médina Yoro Foulah'],
  'Sédhiou': ['Sédhiou', 'Bounkiling', 'Goudomp'],
};

const DepartementSelect = ({ value, onChange }) => {
  return (
    <Select
      showSearch
      style={{ width: "100%" }}
      placeholder="Sélectionnez un département"
      optionFilterProp="children"
      value={value}
      onChange={onChange}
      filterOption={(input, option) =>
        option?.children.toLowerCase().includes(input.toLowerCase())
      }
    >
      {Object.entries(departementsParRegion).map(([region, departements]) => (
        <OptGroup key={region} label={<strong>{region}</strong>}>
          {departements.map((departement) => (
            <Option key={departement} value={departement}>
              {departement}
            </Option>
          ))}
        </OptGroup>
      ))}
    </Select>
  );
};

export default DepartementSelect;
